/**
 * @generated SignedSource<<8b221ee9d1daf79ae36782fb5c2296c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type textWithPagesElementPageFormDialog_PageFragment$data = {
  readonly internalTitle: string;
  readonly " $fragmentSpreads": FragmentRefs<"textWithPagesElementPageForm_TextWithPagesPageFragment">;
  readonly " $fragmentType": "textWithPagesElementPageFormDialog_PageFragment";
};
export type textWithPagesElementPageFormDialog_PageFragment$key = {
  readonly " $data"?: textWithPagesElementPageFormDialog_PageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"textWithPagesElementPageFormDialog_PageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "textWithPagesElementPageFormDialog_PageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "internalTitle",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "textWithPagesElementPageForm_TextWithPagesPageFragment"
    }
  ],
  "type": "TextWithPagesPage",
  "abstractKey": null
};

(node as any).hash = "7d59adc049960bfb08083fe6f5d0f05b";

export default node;
